var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.value),function(val){return _c('div',{staticClass:"w-field"},[_c('span',[_vm._v(_vm._s(val.name)+"：")]),_c('span',[_vm._v(_vm._s(_vm.getTextVal(val)))])])}),(_vm.value.length === 0)?_c('span',[_vm._v("无")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }